import { QueryCache, QueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { toast } from "sonner";
import type { ValidationError } from "@/requests/gen/react-query/fastAPI.schemas";

function getErrorDescription(error: unknown): string {
  if (error instanceof AxiosError) {
    const detail = (error.response?.data as { detail?: unknown } | undefined)
      ?.detail;
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) {
      return (detail as ValidationError[])
        .map((d) => (d?.loc ? `${d.loc.join(".")}: ${d.msg}` : d?.msg))
        .filter(Boolean)
        .join("; ");
    }
    return error.message;
  }
  if (error instanceof Error) return error.message;
  return String(error);
}

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      console.error(`Error in query ${query.queryKey}:`, error);
      toast.error(`Failed to load`, {
        description: getErrorDescription(error),
      });
    },
  }),
});
